import { useCollectionAdministrationTable } from "@pages/collectionAdministration/hooks/useCollectionAdministrationTable"
import CustomTabs from "@UI/CustomTabs/CustomTabs"
import { useEffect } from "react"
import "./styles.css"

const CollectionAdministrationTabs = () => {
  const { handleChangeTabs, getInitialData, tabItems } = useCollectionAdministrationTable()

  useEffect(() => {
    getInitialData({ status: 'all' })
  }, [])

  return (
    <div>
      <CustomTabs
        className="custom-tabs-variant-1"
        items={tabItems}
        onChange={handleChangeTabs}
      />
    </div>
  )
}

export default CollectionAdministrationTabs
